"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioBgNoiseCheckComponentParameters = void 0;
exports.AudioBgNoiseCheckComponentParameters = [
    {
        id: 'audio_file',
        label: 'Audio File',
        description: 'Audio file to analyze for background noise via DNSMOS',
        type: 'string',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'max_reject_ovrl',
        label: 'Max Reject Overall Quality Threshold (OVRL)',
        description: 'Mean overall quality ceiling at or below which audio is flagged as noisy (range 1.0-5.0, default 2.0)',
        type: 'float',
        paramType: 'FLOAT',
        min: 1.0,
        max: 5.0,
        required: false,
    },
    {
        id: 'max_reject_p10_bak',
        label: 'Max Reject 10th-Percentile Noise Threshold (P10 BAK)',
        description: '10th-percentile background noise score ceiling at or below which audio is flagged as noisy (range 1.0-5.0, default 2.65)',
        type: 'float',
        paramType: 'FLOAT',
        min: 1.0,
        max: 5.0,
        required: false,
    },
    {
        id: 'has_bg_noise',
        label: 'Has Background Noise',
        description: 'True when DNSMOS overall quality or 10th-percentile noise score falls at or below its reject ceiling (higher scores are cleaner)',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
    {
        id: 'data',
        label: 'Metadata & Metrics Data',
        description: 'Output JSON object with detailed DNSMOS metrics, aggregation, and thresholds',
        type: 'output',
        paramType: 'ANY',
        required: true,
    },
    {
        id: 'ovrl_score',
        label: 'Overall Quality Score (OVRL)',
        description: 'Mean overall quality score (P.835 OVRL) from DNSMOS',
        type: 'output',
        paramType: 'FLOAT',
        required: true,
    },
    {
        id: 'p10_bak_score',
        label: '10th Percentile Noise Score (P10 BAK)',
        description: '10th-percentile background noise score (P.835 BAK) across sliding windows (-1.0 if unavailable)',
        type: 'output',
        paramType: 'FLOAT',
        required: true,
    },
    {
        id: 'bak_score',
        label: 'Background Noise Score (BAK)',
        description: 'Mean background noise quality score (P.835 BAK) from DNSMOS (-1.0 if unavailable)',
        type: 'output',
        paramType: 'FLOAT',
        required: true,
    },
];
//# sourceMappingURL=AudioBgNoiseCheck.js.map